module.exports = __webpack_public_path__ + "img/home_play_bg.97f818ae.png";